import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicUserFlagService";
const store = {};
const mutations = {
    SET_FLAG() { 
    }, 
};

const state = { 
};

const getters = {};

const actions = { 
    setTopicFlag({ commit }, data ) {
        var formData = new FormData();
        formData.append("Id", data.Id);
        formData.append("FlagNr", data.FlagNr);
        axios
            .post(baseUri + '/SetFlag', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_FLAG', res.data.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
};


export default { 
    state,
    store,
    mutations,
    getters,
    actions
}